<div class="single-match-field">
	<div class="value-content">
		<span class="name">
			{{labelPublicRecord}}:
		</span>
		<span class="value">
			{{dataPublicRecord || '--'}}
		</span>
	</div>
</div>
